import { HELPER_ROLE_MAINHELPER, HELPER_ROLE_ASSISTINGHELPER } from "../constants"
import { useSupabaseClientStore } from '../../stores/supaBaseClientStore'
import { useLogger } from '../../composables/useLogger'

const logger = useLogger()

export class HelperRole {
    id: string
    created_at: string | null
    helperrole: string | null
    helper_id: string | null

    constructor(id: string) {
        this.id = id
    }

    static getSupabase() {
        const supabaseClientStore = useSupabaseClientStore()
        return supabaseClientStore.supabase
    }

    static fromDatabaseRow(row: any) {
        const helperRole = new HelperRole(row.id);
        helperRole.created_at = row.created_at;
        helperRole.helperrole = row.helperrole;
        helperRole.helper_id = row.helper_id;
        return helperRole;
    }

    static async allForHelper(helperId: string) {
        const supabase = this.getSupabase();
        const { data, error } = await supabase
            .from('helperroles')
            .select('*')
            .eq('helper_id', helperId)
        if (error) logger.throwSupabaseError(error, `Failed to get helper roles for helper ${helperId}`);
        logger.debug("HelperRole: allForHelper", { helperId: helperId, helperRoles: data })
        return data.map(this.fromDatabaseRow);
    }

    private static async createHelperRole(helperId: string, helperRole: string): Promise<HelperRole> {
        const supabase = this.getSupabase();
        const { data, error } = await supabase
            .from('helperroles')
            .insert({
                helper_id: helperId,
                helperrole: helperRole
            })
            .select()
            .single();
        if (error) logger.throwSupabaseError(error, `Failed to create helper role ${helperRole} for helper ${helperId}`);
        return this.fromDatabaseRow(data);
    }

    static async createNewMainHelperRole(helperId: string): Promise<HelperRole> {
        return this.createHelperRole(helperId, HELPER_ROLE_MAINHELPER);
    }

    static async createNewAssistingHelperRole(helperId: string): Promise<HelperRole> {
        return this.createHelperRole(helperId, HELPER_ROLE_ASSISTINGHELPER);
    }

    static async delete(helperRoleId: string) {
        const supabase = this.getSupabase();
        const { error } = await supabase
            .from('helperroles')
            .delete()
            .eq('id', helperRoleId);
        if (error) logger.throwSupabaseError(error, `Failed to delete helper role ${helperRoleId}`);
    }

}